import { ProfileSettings } from 'src/app/models/server/profile-settings';

export class DialogProfileSettingsData {
    public settings: ProfileSettings;
    public needViewReloading: boolean = false;
    public constructor() {}
}
